export const THEME_COLORS = {
  white: "#FFFFFF",
  eggshell: "#FFFAEF",
  paleYellow: "#FFF7E4",
  yellow: "#FCECC9",
  peach: "#FFD39E",
  salmon: "#FF5B5B",
}